import Vue from 'vue';
import {
  Form,
  FormItem,
  Input,
  Button,
  Table,
  TableColumn,
  Modal,
  Loading,
} from '@ss/mtd-vue';

Vue.component(Form.name, Form);
Vue.component(FormItem.name, FormItem);
Vue.component(Input.name, Input);
Vue.component(Button.name, Button);
Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);
Vue.component(Modal.name, Modal);
Vue.component(Loading.name, Loading);
